import { Button } from '../../catalyst-ui-kit/button';
import { useTradeFormStore } from './TradeFormState';

export const MidPriceButton = () => {
  const setLimitPrice = useTradeFormStore((x) => x.setLimitPrice);
  const midPrice = useTradeFormStore((x) => x.midPrice);
  return (
    <Button
      text
      size="xs"
      disabled={!midPrice}
      onClick={() => {
        if (!midPrice) {
          return;
        }
        setLimitPrice(midPrice);
      }}
    >
      Mid
    </Button>
  );
};
